import { create } from 'zustand';

interface NotificationStoreState {
  notification: any;
  handleNotification: (channel: any, message: any) => void;
  clearNotification: () => void;
  reconnectTimeoutInMinutes: number;
  logConnectionTime: () => void;
  lastConnectionTime: () => number | null;
}

export const useNotificationStore = create<NotificationStoreState>((set) => ({
  reconnectTimeoutInMinutes: 10,
  logConnectionTime: () => {
    localStorage.setItem('lastNotificationConnection', Date.now().toString());
  },
  lastConnectionTime: () => {
    const time = localStorage.getItem('lastNotificationConnection');
    return time ? parseInt(time, 10) : null;
  },
  notification: {},
  handleNotification: (channel: any, message: any) => {
    set((state) => ({
      ...state,
      notification: { channel, message },
    }));

    // Dispatch DOM CustomEvent for useNotificationListener subscribers
    if (typeof window !== 'undefined') {
      try {
        if (channel) {
          window.dispatchEvent(new CustomEvent(String(channel), { detail: message }));
        }

        const msgObj = typeof message === 'object' && message !== null ? (message as Record<string, any>) : null;
        const configName = msgObj?.configurationName || msgObj?.ConfigurationName || msgObj?.payload?.notificationType;
        if (configName && configName !== channel) {
          window.dispatchEvent(new CustomEvent(String(configName), { detail: message }));
        }

        window.dispatchEvent(new CustomEvent('blocks-notification', { detail: { channel, message } }));
      } catch (err) {
        console.error('Failed to dispatch notification event:', err);
      }
    }
  },
  clearNotification: () => {
    set({ notification: {} });
  },
}));
